import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import ListItemView from './ListItemView';

export default class FilterSidebarView extends Component {

    handleChange(key) {
        var queryTerm = {};
        var type = this.props && this.props.type;
        queryTerm[type] = key;
        if (this.props.type === 'group') {
            this.props.toggleMenuChanged();
        }
        this.props.handleChange(queryTerm);
    }

    renderItems() {
        this.props = this.props || {};
        return this.props.keys.map(function(item) {
            let isSelected = (this.props.value === item.key) || (item.key === '' && !this.props.value);
            return <ListItemView item={item} key={item.key} selectItem={this.handleChange.bind(this, item.key)} isSelected={isSelected} />;
        }, this);
    }

    render() {
        return (
            <Row>
                <Col xs={12}>
                    <span className="community-sidebar-input-title">{this.props.name}</span>
                </Col>
                <ul className="col-xs-12">
                    {this.renderItems()}
                </ul>
            </Row>
        );
    }
}
